import Constant from './Constants';

import {history} from './history';
import {getStore} from './store';
import {mapCluster} from './MapCluster';


export const PAGE_SIZE = 50;

export const INITIAL_FILTER = {
    Residential: {
        propertyType: 'single family',
        transactionType: 'for sale',
        'for sale': {
            min: 0,
            max: 0
        },
        'for rent': {
            min: 0,
            max: 0
        },
        keyword: [],
        openHouse: false
    },
    Commercial: {
        propertyType: 'allcommercial',
        transactionType: 'for sale',
        'for sale': {
            min: 0,
            max: 0
        },
        keyword: [],
        openHouse: false
    }

};

const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
});


const isNotEmpty = (value) => {
    // const t0 = performance.now();
    const result= !(value === undefined || value === null || value.toString().trim() === '');
    // const t1 = performance.now();

    // console.log('Call to doSomething took ' + (t1 - t0) + ' milliseconds.');

    return result;
};


const equals = (a, b) => {
    return typeof a === 'string' && typeof b === 'string'
        ? a.localeCompare(b, undefined, {sensitivity: 'accent'}) === 0
        : a === b;
};


const sortBy = (field, order, type) => {
    let parser = undefined;

    if (type === 'number') {
        parser = parseFloat;
    } else if (type === 'string') {
        parser = (a) => a.toLowerCase();
    }

    const key = parser ? (x) => parser(x.properties[field]) : (x) => x.properties[field];

    const reverse = order === 'ASC' ? 1 : -1;

    return (a, b) => {
        return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
    };
};


export {
    Constant as constant,
    history,
    getStore,
    formatter,
    mapCluster,
    sortBy,
    isNotEmpty,
    equals
};
